/** DataGridPro style of the maquette (headers 36px, rows 44px, light grey borders). */
const FOOTER_BG = '#FAFAFA';
const FOOTER_TEXT = '#919EAB';
const GRID_BORDER = 'rgba(145, 158, 171, 0.2)';

export const ROW_H = 44;
export const HEADER_H = 36;
export const FOOTER_H = 40;
/** The grid is as tall as 10 rows at most: bigger pages scroll inside it. */
export const MAX_VISIBLE_ROWS = 10;

/**
 * Fixed height of the grid when the page holds more than 10 rows (internal scroll), `null` otherwise
 * (autoHeight). `pinnedRows` = rows pinned outside the scroll (TOTAL).
 */
export const cappedGridHeight = (rowsOnPage: number, pinnedRows = 0) =>
  rowsOnPage > MAX_VISIBLE_ROWS ? HEADER_H + (MAX_VISIBLE_ROWS + pinnedRows) * ROW_H + FOOTER_H + 2 : null;

export const rowsOnPage = (rowCount: number, page: number, pageSize: number) =>
  Math.max(0, Math.min(pageSize, rowCount - page * pageSize));

export const GRID_SX = {
  border: 'none',
  fontFamily: 'Public Sans',
  '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader': {
    backgroundColor: 'rgba(226, 229, 233, 0.16)',
  },
  '& .MuiDataGrid-columnHeaderTitle': { fontSize: 14, fontWeight: 600, color: '#637381' },
  '& .MuiDataGrid-cell': {
    fontSize: 14,
    color: '#2F3843',
    borderColor: 'rgba(145, 158, 171, 0.2)',
    borderRight: '1px solid rgba(145, 158, 171, 0.2)',
    display: 'flex',
    alignItems: 'center',
  },
  // Pagination footer — same values as the Visibility Local and Explore grids (Figma 6848:11211).
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: FOOTER_BG,
    borderTop: `1px solid ${GRID_BORDER}`,
    minHeight: 40,
    height: 40,
    '& .MuiToolbar-root': {
      minHeight: 40,
      height: 40,
      paddingRight: '24px',
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiInputBase-root': {
      color: FOOTER_TEXT,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '22px',
    },
    '& .MuiTablePagination-input': {
      border: `1px solid ${GRID_BORDER}`,
      borderRadius: '6px',
      height: 30,
      marginLeft: '12px',
      marginRight: '32px',
      paddingLeft: '8px',
      '& .MuiSelect-icon': {
        width: 16,
        height: 16,
        top: 'calc(50% - 8px)',
        color: FOOTER_TEXT,
      },
    },
    '& .MuiTablePagination-actions': {
      marginLeft: '8px',
      '& .MuiIconButton-root': {
        width: 34,
        height: 34,
        color: FOOTER_TEXT,
        // Greyed out when there is no previous / next page (the color above would hide MUI's disabled state).
        '&.Mui-disabled': { color: 'rgba(145, 158, 171, 0.4)' },
      },
    },
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
} as const;

export const CARD_SX = {
  bgcolor: 'background.paper',
  border: '1px solid #DFE3E8',
  borderRadius: '12px',
  overflow: 'hidden',
} as const;

export const TABLE_HEADER_SX = {
  minHeight: 40,
  px: '20px',
  borderBottom: '1px solid #EAEAEA',
} as const;
